module.exports = __webpack_public_path__ + "static/media/image.a4e48add.jpg";